export type LocaleUrls = {
  de: string;
  default: string;
};

export const getMainMenuExternalUrl = (
  language: string | undefined,
  urls: LocaleUrls,
): string =>
  language?.toLowerCase().startsWith('de') ? urls.de : urls.default;

export const MAIN_MENU_EXTERNAL_LINKS = {
  helpWhatsNew: {
    de: 'https://gumb.app/support/versionshinweise/',
    default: 'https://gumb.app/en/support/release-notes/',
  },
  helpGuides: {
    de: 'https://gumb.app/support/',
    default: 'https://gumb.app/en/support/',
  },
  helpAdminManual: {
    de: 'https://gumb.app/support/admin-handbuch/',
    default: 'https://gumb.app/en/support/guide-for-admins/',
  },
  helpContactUs: {
    de: 'https://gumb.app/contact-us/',
    default: 'https://gumb.app/en/contact-us/',
  },
  helpSendFeedback: {
    de: 'https://gumb.app/contact-us/',
    default: 'https://gumb.app/en/contact-us/',
  },
  aboutRoadmap: {
    de: 'https://gumb.app/support/roadmap/',
    default: 'https://gumb.app/en/support/roadmap/',
  },
  aboutAboutUs: {
    de: 'https://gumb.app/about-us/',
    default: 'https://gumb.app/en/about-us/',
  },
  aboutWebsite: {
    de: 'https://gumb.app/de',
    default: 'https://gumb.app',
  },
} as const;

export type MainMenuExternalLinkKey = keyof typeof MAIN_MENU_EXTERNAL_LINKS;
